import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const all = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/costs/all?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de todos os custos')
        })
}

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/costs?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de custos')
        })
}

const find = (id) => {
    return api.get(`/costs/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o custo')
        })
}

const store = (data) => {
    return api.post('/costs', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar o custo')
        })
}

const update = (data) => {
    return api.put(`/costs/${data.id}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar o custo')
        })
}

const destroy = (id) => {
    return api.delete(`/costs/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível excluir o custo')
        })
}

export default {
    all,
    findAll,
    find,
    store,
    update,
    destroy
}
